export const SESTest_Custom = [
  {
    domainName: "eval1.direct-address.com",
    data: {
      "data-domain-name": "eval1.direct-address.com",
      layout_title: "Secure Exchange Solutions Messaging",
      layout_subpage_title: "- Secure Exchange Solutions- Direct Mail",
      "allow-non-direct-mail-access": "true",
      time_out: "2",
      "tfa-enabled": "true",
    },
  },
  {
    domainName: "crispdirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "CRISP Direct Messaging",
      layout_subpage_title: "- CRISP - Direct Mail",
    },
  },
  {
    domainName: "ctproviderdirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "CT Provider Direct Messaging",
      layout_subpage_title: "- CT Provider - Direct Mail",
    },
  },
  {
    domainName: "hospitaladmin.nchiedirect.net",
    data: {
      "data-domain-name": "",
      layout_title: "NC HealthConnex Direct Messaging",
      layout_subpage_title: "- NC HealthConnex - Direct Mail",
    },
  },
  {
    domainName: "multitenancy.direct-address.com",
    data: {
      "data-domain-name": "",
      layout_title: "Custom branding testing",
      layout_subpage_title: "- test - Direct Mail",
    },
  },
];
